const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/0e2276ed40d9f1ce2a3a2d381b6cbd96/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  urlL: 'https://res.insta360.com/static/d188e412374754a29fed542f78e2deeb/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@3x.jpg',
  url_m:
    'https://res.insta360.com/static/0e2276ed40d9f1ce2a3a2d381b6cbd96/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD@2x.jpg',
  url_s:
    'https://res.insta360.com/static/8b6813caa4d3eadc4482c4000e1b2aef/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E7%99%BD.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/b33e3899b62d5121ae8087eae85d6101/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/c71a0ee74301f3b209ee969a511baa89/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@3x.jpg',
  url_m:
    'https://res.insta360.com/static/b33e3899b62d5121ae8087eae85d6101/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91@2x.jpg',
  url_s:
    'https://res.insta360.com/static/6e9f742beb48572a15bf97032d477628/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9001-%E9%BB%91.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/a24390f55d2a14e85dbd5e4678e68f39/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  urlL: 'https://res.insta360.com/static/72996de7187e8604281c361fd98ce95d/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@3x.jpg',
  url_m:
    'https://res.insta360.com/static/a24390f55d2a14e85dbd5e4678e68f39/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002@2x.jpg',
  url_s:
    'https://res.insta360.com/static/d6279cfc469c012ed8f762542fd6ff6f/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9002.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/8903e098a519fcd673f9ad903e3d6f55/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  urlL: 'https://res.insta360.com/static/859fbec1c8e31f74fbf63a437f53ce04/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@3x.jpg',
  url_m:
    'https://res.insta360.com/static/8903e098a519fcd673f9ad903e3d6f55/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003@2x.jpg',
  url_s:
    'https://res.insta360.com/static/755ce376e1d46b7704c4614d98b31763/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9003.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/4418698671b6fb94030a568e730a1702/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  urlL: 'https://res.insta360.com/static/c44b3582ea8c2c6bd41bf6bf1e012db4/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@3x.jpg',
  url_m:
    'https://res.insta360.com/static/4418698671b6fb94030a568e730a1702/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004@2x.jpg',
  url_s:
    'https://res.insta360.com/static/7b0d4dfa5e64caf20418f6a53f53276c/%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%90%E6%A0%87%E5%87%86%E5%A5%97%E9%A4%9004.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/136a559c4b402a08ce27d0ffaf80b032/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/d0436659c741cb6f9e332558d1011199/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/136a559c4b402a08ce27d0ffaf80b032/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/69ff79503dc8df52206f13d745c4c63e/01.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/80ad88b1318ce71a7411980c39f41eb7/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/09d4642612f7f99fa1bfc16014892fb1/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/80ad88b1318ce71a7411980c39f41eb7/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/6e9f19a87539124cfa27f01d074de512/02-%E9%BB%91.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/4e6bc8acbbbf353ae506abf4b6385445/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/711614e7206edc028247f9c5c8231200/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/4e6bc8acbbbf353ae506abf4b6385445/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/995b3a750251d0e34de17b90ff6ce3d6/03.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/785f35f0a980bc03d021f58725ba8493/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/4a8387b05919807976f3022d0d7ec711/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/785f35f0a980bc03d021f58725ba8493/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/96785f2a69a8d02390bc62e5c04eda39/04.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/ac4edf12c622ce4af3038d6b7345739a/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/6c4c1df6b37b926963540e2e71efd076/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/ac4edf12c622ce4af3038d6b7345739a/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/c049ee4370ceea66efc7e250d89a1f6b/05.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/db48f3cdee824b0b91d38acc587c85d6/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/7f1fccff4424e8d36124fb352e13468c/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/db48f3cdee824b0b91d38acc587c85d6/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/4da9ab85fed212ae4903faa4d5896f31/01.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/1f04377956a3b6fddc36fd79d768891d/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/1229e526ec0200344e72523e36af959b/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/1f04377956a3b6fddc36fd79d768891d/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/24da2068578f974bf7332c1a8939d6e4/02-%E9%BB%91.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/2c2d55ac7c2de4b1e0e465e12db43bda/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/65f574c482a9d0b15bf1694fe4db90fb/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/2c2d55ac7c2de4b1e0e465e12db43bda/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/ca3aa8a7db5d7cab5ad4ed377cd27a8a/03.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/6227294ddc8f18df8df436271ea6abcf/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/7412fd9a76ac63f30f7643692d1e61d8/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/6227294ddc8f18df8df436271ea6abcf/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/e92bd025c5b4bcac65ad819a6b00dd2d/04.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/cca9fd044d17456f76e79ee0de2a4b00/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/5b0e2bbb0b53996db7e10ee2d6da10d6/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/cca9fd044d17456f76e79ee0de2a4b00/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/bc42cd347dbcdd8076398440a2f65d4b/05.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/92ef7cd78806c44ac43bc5d32e8972eb/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/453989604bfd0eb7486c380a12f52cfd/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/92ef7cd78806c44ac43bc5d32e8972eb/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/78eccaa78a27d35c24019f0ecd8371ec/01.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/0723b90bc16938e9c4edc1cdfba84aec/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/db698d93a4fdf45ef0acc9bfed31458f/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/0723b90bc16938e9c4edc1cdfba84aec/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/7b391bef107eee455d440587ec0a070f/02-%E9%BB%91.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/41be696af898fd4a43fdda90f5d58225/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/7b5577ae78a1e3d6a5e5b775ab99632a/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/41be696af898fd4a43fdda90f5d58225/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/6003d1d52c5a520d45b2513e04653d69/03.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/9b612e7d7795bbc28461a997f8eefcf4/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/60873eeb3f4d2e64e521d72176c50ab0/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/9b612e7d7795bbc28461a997f8eefcf4/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/0e6fe067315f0c70778a8a6b82550380/04.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/70d430a5f40b8fac8ac220083b093cba/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/f5ad69d2e7693a21cfb8df02cdac485e/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/70d430a5f40b8fac8ac220083b093cba/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/83ed5a1ba9203552f7b727096324c66a/05.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/d0c0ee52f4c15edbbc01658b04656278/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/3205caf5d5c992da533eb592a4db4b49/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/d0c0ee52f4c15edbbc01658b04656278/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/eed184995598087095cf510afa63826f/01.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/742dd8b03416e00286cd866ea4e9cc07/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/9cbb650781b478ede3d4ad971b1956f7/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/742dd8b03416e00286cd866ea4e9cc07/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/9798cd42cc68c8b952ed63e8e8d44e48/02-%E9%BB%91.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/7f8f9f1ef02639e9020f9eceb6b359a0/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/bdcc295dc496c34f94d6a048f672fcbb/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/7f8f9f1ef02639e9020f9eceb6b359a0/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/30d4a53b8d9265199e64a4004231248b/03.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/d71f49c6d5e78185369311a1bec140b2/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/7080918f9ac5098105561d996c263b54/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/d71f49c6d5e78185369311a1bec140b2/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/47f355b23a5e80ee57061c5ffa6675b7/04.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/5c0f5cd38bc77c6a1d6cb4ab62888edd/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/a8490bd838c4ef4f96b9ce798a05e109/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/5c0f5cd38bc77c6a1d6cb4ab62888edd/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/1ef0d668bf838317cc5b5d6c01d0e330/05.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/997a4c89fbf5b53f51377db759f74094/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/da1c499702c885b52dca7ab02b10ca03/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/997a4c89fbf5b53f51377db759f74094/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/ecc6c7aa97655261c261fb1b9874a74e/01.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/858afd504e0b71cbefd1ccc5f7c460d5/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/2e33eb2f864e1e445bb54a9abe0fb8d0/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/858afd504e0b71cbefd1ccc5f7c460d5/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/c83a8f9bd701b6d68b65b54ea27e2fea/02-%E9%BB%91.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/cd2370008dbeecd626fb01d7a9eb833b/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/edfba75d5803e27efe30466f0f43661c/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/cd2370008dbeecd626fb01d7a9eb833b/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/65a69431915d60428275943d27ca7bb7/03.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/379f0bd11dad538430d2cb6f40e16cca/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/351e9193901e5e084ada821b13b2c111/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/379f0bd11dad538430d2cb6f40e16cca/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/35729140c2840e872a5ba199fda72bee/04.jpg',
};

const resourcesMapperTW = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperTW;
